import { z } from 'zod';

import { zodAddressSchema } from '@vestigas/data';

import { zodCompanyAdminSchema } from '../validations';

export const zodMatchCompanyRequestSchema = z.object({
  address: zodAddressSchema,
  name: z.string(),
});

/**
 * The match endpoint returns the same `CompanyInternalResponse` shape as the
 * single-company admin GET endpoint (a 404, handled separately, signals "no
 * match" rather than a nullable body).
 */
export const zodMatchCompanyResponseSchema = zodCompanyAdminSchema;
